import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { debounce } from 'lodash';
import './Page.css';
import PageNumber from '../page-number/PageNumber';
import { setIsActive } from '../../redux/actions/entities/pages';
import {
  isImageInChange,
  MmToPx,
} from '../../redux/helpers';
import Texture from '../texture/Texture';
import { addPageToViewed } from '../../redux/actions/ui/addPageToViewed';


class Page extends Component {
  constructor(args) {
    super(args);
  }

  setIsActivePage = () => {
    const {
      pageId,
      isChange,
      isCover,
      lang,
    } = this.props;


    if (isImageInChange(isChange, isCover, lang)) {
      return true;
    }

    this.props.dispatch(addPageToViewed(pageId));
    this.props.dispatch(setIsActive(pageId));
  }

  renderCanvas(placeholders, isPreview = false) {
    if (!placeholders) {
      return;
    }

    const previews = placeholders.map((texture, index) => {
      const {
        left,
        top,
        height,
        width,
      } = texture;

      const {
        pages,
        isChange,
        images,
        pageId: currentPageId,
        bookProperties,
      } = this.props;

      const activePage = pages[currentPageId] || pages.byId[currentPageId];

      if (activePage === undefined || !bookProperties.cover.coverSizes) {
        return false;
      }

      const layoutHeight = activePage.isCover ? MmToPx(bookProperties.cover.coverSizes.height) : bookProperties.bookSizes.height;
      const ratio = isPreview ? 650 / layoutHeight : 65 / layoutHeight;

      const placeholderstyle = {
        left: left * ratio,
        top: top * ratio,
      };

      const pageId = activePage.id;

      const pStyle = {
        width: Math.round(width * ratio),
        height: Math.round(height * ratio),
        position: 'absolute',
        display: 'inline-block',
        left: left * ratio,
        top: top * ratio,
      };

      return (
        <div className="page-preview" style={pStyle} key={index} >
          <Texture
            texture={texture}
            style={placeholderstyle}
            ratio={ratio}
            droppedImages={activePage.droppedImages}
            activePageplaceholders={activePage.placeholders}
            isChange={isChange}
            pageId={pageId}
            pages={pages}
            images={images.byId}
            index={index}
            isPreview
          />
        </div>
      );
    });

    return previews;
  }

  render() {
    const {
      active,
      pageData,
      placeholders,
      width,
      height,
      backgroundColor,
      backgroundImage,
    } = this.props;

    const {
      current,
      all,
    } = pageData;

    return (

      <div
        className={`Page ${active ? 'active' : ''}`}
        onClick={this.setIsActivePage}
        role="presentation"
        style={{
          width,
          height,
          backgroundColor,
          backgroundImage: backgroundImage !== '' ? `url(${backgroundImage})` : '',
          minWidth: width,
        }}
      >
        {this.renderCanvas(placeholders)}
        <PageNumber current={current} all={all} />
      </div>


    );
  }
}

Page.defaultProps = {
  pageData: {},
  active: false,
  pageId: 0,
  placeholders: [],
  width: 0,
  height: 0,
  backgroundColor: 'white',
  pages: {},
  images: {},
  bookProperties: {},
  isChange: false,
  isCover: false,
  lang: {},
  texts: {},
  backgroundImage: '',
  dispatch: () => {},
};

Page.propTypes = {
  pageData: PropTypes.object,
  active: PropTypes.bool,
  pageId: PropTypes.number,
  placeholders: PropTypes.array,
  width: PropTypes.number,
  height: PropTypes.number,
  backgroundColor: PropTypes.string,
  pages: PropTypes.object,
  images: PropTypes.object,
  bookProperties: PropTypes.object,
  isChange: PropTypes.bool,
  isCover: PropTypes.bool,
  lang: PropTypes.object,
  texts: PropTypes.object,
  backgroundImage: PropTypes.string,
  dispatch: PropTypes.func,
};

export default connect(state => ({
  layouts: state.entities.layouts.allIds,
  layoutsById: state.entities.layouts.byId,
  bookProperties: state.bookProperties,
  texts: state.entities.texts,
}
))(Page);



// WEBPACK FOOTER //
// ./src/components/page/Page.jsx